//generates last N years starting with current year

const getLastNYears = (N = 0) => {
  const date = new Date();
  const currentYear = date.getFullYear();
  return Array.from([...Array(N).keys()], (i) => String(currentYear - i));
};
export default getLastNYears;
